import {
  CALENDAR_HOUR_ROW_PX,
  sessionEndHour,
  sessionStartHour,
} from "./calendarUtils";

export function layoutDayEvents(sessions) {
  const items = sessions
    .map((sess) => ({
      sess,
      start: new Date(sess.start_datetime).getTime(),
      end: new Date(sess.end_datetime).getTime(),
      lane: 0,
      laneCount: 1,
    }))
    .sort((a, b) => a.start - b.start || a.end - b.end);

  const laneEnds = [];

  for (const item of items) {
    let lane = laneEnds.findIndex((end) => end <= item.start);
    if (lane === -1) {
      lane = laneEnds.length;
      laneEnds.push(0);
    }
    item.lane = lane;
    laneEnds[lane] = item.end;
  }

  for (const item of items) {
    const overlapping = items.filter(
      (other) => other.start < item.end && other.end > item.start,
    );
    item.laneCount = Math.max(...overlapping.map((o) => o.lane + 1), 1);
  }

  return items;
}

export function eventBlockStyle(item, { hourStart = 0 } = {}) {
  const startH = sessionStartHour(item.sess);
  const endH = Math.max(sessionEndHour(item.sess), startH + 0.5);
  const topPx = (startH - hourStart) * CALENDAR_HOUR_ROW_PX;
  const heightPx = Math.max((endH - startH) * CALENDAR_HOUR_ROW_PX - 4, 36);
  const widthPct = 100 / item.laneCount;
  const leftPct = item.lane * widthPct;

  return {
    top: `${topPx + 2}px`,
    height: `${heightPx}px`,
    left: `calc(${leftPct}% + 3px)`,
    width: `calc(${widthPct}% - 6px)`,
  };
}

export function isWeekendDay(dayStr) {
  const day = new Date(`${dayStr}T12:00:00`).getDay();
  return day === 0 || day === 6;
}
